module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/hotsale-desktop.42d5a010.jpg";